"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    shadows = _ref.shadows;
  return {
    fabRoot: {
      backgroundColor: palette.card.main,
      boxShadow: shadows[1],
      '&:hover': {
        backgroundColor: palette.secondary.main,
        boxShadow: shadows[3]
      }
    }
  };
});
var View = function View(_ref2) {
  var title = _ref2.title,
    _onClick = _ref2.onClick,
    children = _ref2.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    disableRipple: true,
    disableFocusRipple: true,
    component: "div",
    classes: {
      root: classes.fabRoot
    },
    onClick: function onClick(e) {
      if (_onClick) _onClick(e);
    }
  }, children));
};
View.displayName = 'FabButton';
var _default = exports["default"] = View;
//# sourceMappingURL=FabButton.js.map